import React, { useEffect, useState } from "react";
import NewFormTextInput from "../../../../../components/FormTextInput/NewFormTextInput";
import AutoCompleteField from "../../../../../components/AutoCompleteField/AutoCompleteField";
import styles from "./Edufin.module.css";
import { Grid, InputLabel } from "@mui/material";
import CountryCodePhoneInput from "../../../../../components/CountryCodePhoneInput/CountryCodePhoneInput";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import { useNavigate } from "react-router-dom";
import { ErrorType } from "../../../../../components/FormTextInput/types";
import { getYears } from "../../../../../components/CommonFunctions/CommonFunctions";
import moment from "moment";
import { resetEdufinSaveSuccess } from "../../service/EdufinSlice";
import { useDispatch } from "react-redux";

const CourseDetailsForEdufin = ({
  setShowIndex,
  SaveEdufinData,
  saveEdufinSuccess,
  saveEdufinData,
  courses,
  setCourses,
  instituteInfoForCourse,
  setInstituteInfoForCourse,
}: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showErrMsz, setShowErrMsz] = React.useState<boolean>(true);
  const [errorType, setErrorType] = React.useState<ErrorType>("client");
  const [validStateInstituteType, setValidStateInstituteType] =
    React.useState<boolean>(true);
  const [instituteName, setInstituteName] = React.useState<boolean>(true);
  const [courseName, setCourseName] = React.useState<boolean>(true);
  const [courseStartYear, setCourseStartYear] = React.useState<boolean>(true);
  const [duration, setDuration] = React.useState<boolean>(true);
  const [noOfStudents, setNoOfStudents] = React.useState<boolean>(true);
  const [tutionFees, setTutionFees] = React.useState<boolean>(true);
  const [transportFees, setTransportFees] = React.useState<boolean>(true);
  const [otherFees, setOtherFees] = React.useState<boolean>(true);
  const [totalFees, setTotalFees] = React.useState<boolean>(true);

  const handleAddCourse = () => {
    setCourses((prev: any) => [
      ...prev,
      {
        id: prev?.length,
        courseName: "",
        courseStartYear: "",
        duration: "",
        noOfStudents: "",
        tutionFees: "",
        transportFees: "",
        otherFees: "",
        totalFees: "",
      },
    ]);
  };

  const handleChange = React.useCallback(
    (event: any) => {
      setShowErrMsz(true);
      setErrorType("client");
      const { id, value } = event.target;
      const lowercaseValue =
        id === "instituteEmail"
          ? value.toLowerCase().trimStart()
          : id === "instituteName"
          ? value?.replace(/[^a-zA-Z\s]/g, "")
          : value.trimStart();

      setInstituteInfoForCourse({
        ...instituteInfoForCourse,
        [id]: lowercaseValue,
      });
    },
    [setInstituteInfoForCourse]
  );

  const handleChangeForCourse = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, courseId: number) => {
      setShowErrMsz(true);
      setErrorType("client");
      const { id, value } = event.target;

      const processedValue =
        id === "instituteEmail"
          ? value.toLowerCase().trimStart()
          : id === "otherFees" ||
            id === "totalFees" ||
            id === "tansportFees" ||
            id === "tutionFees" ||
            id === "noOfStudents"
          ? value?.replace(/[^0-9]/g, "")
          : id === "courseName"
          ? value?.replace(/[^a-zA-Z\s]/g, "")
          : value.trimStart();

      setCourses((prevCourses: any) =>
        prevCourses.map((course: any) =>
          course.id === courseId
            ? {
                ...course,
                [id]: processedValue,
              }
            : course
        )
      );
    },
    []
  );

  const instituteType = [
    { id: 0, value: "School" },
    { id: 1, value: "Colleges" },
    { id: 2, value: "Universities" },
    { id: 3, value: "Institutes" },
  ];

  const durationType = [
    { id: 0, value: "1-12 months" },
    { id: 1, value: "15 months" },
    { id: 2, value: "18 months" },
    { id: 3, value: "24 months" },
    { id: 4, value: "36 months" },
    { id: 5, value: "48 months" },
  ];
  const yearOptions = getYears(moment().year() - 20, moment().year())
    .reverse()
    .map((year, index) => ({
      id: index,
      value: year.toString(), // keep it string like your board values
    }));

  const defaultOptionForInstituteType = instituteType
    ? instituteType?.find(
        (branch: any) => branch?.value === instituteInfoForCourse?.instituteType
      )
    : "";

  const setValidateInstituteName = React.useCallback((val: boolean) => {
    setInstituteName(val);
  }, []);

  const setValidateCourseName = React.useCallback((val: boolean) => {
    setCourseName(val);
  }, []);

  const setValidateNoOfStudents = React.useCallback((val: boolean) => {
    setNoOfStudents(val);
  }, []);

  const setValidateTutionFees = React.useCallback((val: boolean) => {
    setTutionFees(val);
  }, []);

  const setValidateTransportFees = React.useCallback((val: boolean) => {
    setTransportFees(val);
  }, []);

  const setValidateOtherFees = React.useCallback((val: boolean) => {
    setOtherFees(val);
  }, []);

  const setValidateTotalFees = React.useCallback((val: boolean) => {
    setTotalFees(val);
  }, []);

  const onInstituteTypeChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setInstituteInfoForCourse({
          ...instituteInfoForCourse,
          instituteType: value?.value,
        });
        setValidStateInstituteType(true);
      } else {
        setInstituteInfoForCourse({
          ...instituteInfoForCourse,
          instituteType: "",
        });
        setValidStateInstituteType(false);
      }
    },
    [instituteInfoForCourse]
  );

  const onCourseStartYearChange = React.useCallback(
    (courseId: number, value: any | null) => {
      setCourses((prevCourses: any) =>
        prevCourses.map((course: any) =>
          course.id === courseId
            ? { ...course, courseStartYear: value ? value.value : "" }
            : course
        )
      );
      setCourseStartYear(value !== null);
    },
    []
  );

  // update duration
  const onDurationChange = React.useCallback(
    (courseId: number, value: any | null) => {
      setCourses((prevCourses: any) =>
        prevCourses.map((course: any) =>
          course.id === courseId
            ? { ...course, duration: value ? value.value : "" }
            : course
        )
      );
      setDuration(value !== null);
    },
    []
  );

  const handleFinalSubmit = () => {
    if (!instituteInfoForCourse.instituteName) {
      setInstituteName(false);
      return;
    }
    if (!instituteInfoForCourse.instituteType) {
      setValidStateInstituteType(false);
      return;
    }

    for (const course of courses) {
      if (!course.courseName) {
        setCourseName(false);
        return;
      }
      if (!course.courseStartYear) {
        setCourseStartYear(false);
        return;
      }
      if (!course.duration) {
        setDuration(false);
        return;
      }
      if (!course.noOfStudents) {
        setNoOfStudents(false);
        return;
      }
      if (!course.tutionFees) {
        setTutionFees(false);
        return;
      }
      if (!course.transportFees) {
        setTransportFees(false);
        return;
      }
      if (!course.otherFees) {
        setOtherFees(false);
        return;
      }
      // if (!course.totalFees) {
      //   setTotalFees(false);
      //   return;
      // }
    }

    const payloadCourses = courses.map((c: any) => ({
      ...c,
      totalFees:
        Number(c.tutionFees || 0) +
        Number(c.transportFees || 0) +
        Number(c.otherFees || 0),
    }));

    const instituteData = JSON.parse(
      localStorage.getItem("instituteData") || "{}"
    );
    const payload = {
      ...instituteData,
      loanApplicationData: {
        ...instituteData.loanApplicationData,
        instituteInfo: {
          instituteName: instituteInfoForCourse?.instituteName,
          instituteType: instituteInfoForCourse?.instituteType,
        },
        courseDetail: payloadCourses,
      },
      isPartiallyFilled: false,
      id: saveEdufinData?.id,
    };
    SaveEdufinData(payload);
    localStorage.setItem("instituteData", "");
  };

  useEffect(() => {
    if (
      saveEdufinSuccess === true &&
      saveEdufinData?.isPartiallyFilled === false
    ) {
      navigate(`/app/Integrations/EdufinDetails/EdufinDetailsForDraftState`);
      dispatch<any>(resetEdufinSaveSuccess());
    }
  }, [saveEdufinSuccess]);

  useEffect(() => {
    const instituteData = JSON.parse(
      localStorage.getItem("instituteData") || "{}"
    );
    if (instituteData) {
      setInstituteInfoForCourse({
        ...instituteInfoForCourse,
        instituteName:
          instituteData?.loanApplicationData?.instituteDetail?.instituteName,
        instituteType:
          instituteData?.loanApplicationData?.instituteDetail?.instituteType,
      });
    }
  }, []);

  return (
    <div>
      <div className={styles.instutueDetailsContainer}>
        <div className={styles.groupHeader}>Institute Details</div>
        <div className={styles.instutueDetailsBox}>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="Institute Name"
                type="text"
                id={"instituteName"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                error={!instituteName}
                setValidStatus={setValidateInstituteName}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={instituteInfoForCourse?.instituteName}
              />
            </div>
            <div style={{ width: "500px" }}>
              <AutoCompleteField
                id="branchId"
                label="Institute Type"
                options={instituteType}
                optionLabel={"value"}
                required={true}
                onChange={onInstituteTypeChange}
                value={defaultOptionForInstituteType}
                validState={validStateInstituteType}
                disableClearable={
                  instituteInfoForCourse?.instituteType === "" ? true : false
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.instutueDetailsContainer}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className={styles.groupHeader}>Course Details</div>
          <div
            style={{
              marginBottom: "10px",
            }}
          >
            <SaveBtn
              buttonText={"Add Course"}
              onClick={() => {
                handleAddCourse();
              }}
            />
          </div>
        </div>
        {courses.map((course: any, index: any) => {
          const selectedYear =
            yearOptions.find((y) => y.value === course.courseStartYear) || null;

          const selectedDuration =
            durationType.find((d) => d.value === course.duration) || null;
          return (
            <div key={course.id} className={styles.instutueDetailsBoxForCourse}>
              <div className={styles.groupingBox}>
                <div style={{ width: "500px" }}>
                  <NewFormTextInput
                    validate={true}
                    label="Course Name"
                    type="text"
                    id={"courseName"}
                    inputProps={{
                      maxLength: 100,
                    }}
                    require={true}
                    onChange={(e: any) => handleChangeForCourse(e, course.id)}
                    error={!courseName}
                    setValidStatus={setValidateCourseName}
                    showErrorMessage={showErrMsz}
                    errorType={errorType}
                    value={course?.courseName}
                  />
                </div>
                <div style={{ width: "500px" }}>
                  <AutoCompleteField
                    id="courseStartYear"
                    label="Course Start Year"
                    options={yearOptions}
                    optionLabel="value"
                    required={true}
                    value={selectedYear}
                    validState={courseStartYear}
                    onChange={(_: any, value: any) =>
                      onCourseStartYearChange(course.id, value)
                    }
                  />
                </div>
              </div>

              <div className={styles.groupingBox}>
                <div style={{ width: "500px" }}>
                  <AutoCompleteField
                    id="duration"
                    label="Duration"
                    options={durationType}
                    optionLabel="value"
                    required={true}
                    value={selectedDuration}
                    validState={duration}
                    onChange={(_: any, value: any) =>
                      onDurationChange(course.id, value)
                    }
                  />
                </div>
                <div style={{ width: "500px" }}>
                  <NewFormTextInput
                    validate={true}
                    label="No of Students"
                    type="text"
                    id={`noOfStudents`}
                    inputProps={{ maxLength: 100 }}
                    require={true}
                    onChange={(e: any) => handleChangeForCourse(e, course.id)}
                    error={!noOfStudents}
                    setValidStatus={setValidateNoOfStudents}
                    showErrorMessage={showErrMsz}
                    errorType={errorType}
                    value={course?.noOfStudents}
                  />
                </div>
              </div>

              <div className={styles.groupingBox}>
                <div style={{ width: "500px" }}>
                  <NewFormTextInput
                    validate={true}
                    label="Tuition Fee"
                    type="text"
                    id={`tutionFees`}
                    inputProps={{ maxLength: 100 }}
                    require={true}
                    onChange={(e: any) => handleChangeForCourse(e, course.id)}
                    error={!tutionFees}
                    setValidStatus={setValidateTutionFees}
                    showErrorMessage={showErrMsz}
                    errorType={errorType}
                    value={course?.tutionFees}
                  />
                </div>
                <div style={{ width: "500px" }}>
                  <NewFormTextInput
                    validate={true}
                    label="Transport Fee"
                    type="text"
                    id={`transportFees`}
                    inputProps={{ maxLength: 100 }}
                    require={true}
                    onChange={(e: any) => handleChangeForCourse(e, course.id)}
                    error={!transportFees}
                    setValidStatus={setValidateTransportFees}
                    showErrorMessage={showErrMsz}
                    errorType={errorType}
                    value={course?.transportFees}
                  />
                </div>
              </div>
              <div className={styles.groupingBox}>
                <div style={{ width: "500px" }}>
                  <NewFormTextInput
                    validate={true}
                    label="Other Fees"
                    type="text"
                    id={`otherFees`}
                    inputProps={{ maxLength: 100 }}
                    require={true}
                    onChange={(e: any) => handleChangeForCourse(e, course.id)}
                    error={!otherFees}
                    setValidStatus={setValidateOtherFees}
                    showErrorMessage={showErrMsz}
                    errorType={errorType}
                    value={course?.otherFees}
                  />
                </div>
                <div style={{ width: "500px" }}>
                  <NewFormTextInput
                    validate={true}
                    label="Total Fees"
                    type="text"
                    id={`totalFees`}
                    inputProps={{ maxLength: 100 }}
                    require={true}
                    onChange={(e: any) => handleChangeForCourse(e, course.id)}
                    error={!totalFees}
                    setValidStatus={setValidateTotalFees}
                    showErrorMessage={showErrMsz}
                    errorType={errorType}
                    value={
                      Number(course?.otherFees) +
                      Number(course?.transportFees) +
                      Number(course?.tutionFees)
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.buttonContainer}>
        <SaveBtn
          buttonText={"Submit"}
          onClick={() => {
            handleFinalSubmit();
          }}
        />
      </div>
    </div>
  );
};

export default CourseDetailsForEdufin;
